<template>
  <div class="header_menu">
    <div class="menu_box flex">
      <div
        class="menu_content"
        v-for="(item, index) in headerMenuList"
        :key="index"
        @mouseleave="leave"
        :class="activeIndexObj.activeIndex == index + 1 ? 'menuActive' : ''"
      >
        <div
          @click="changePath(index, item.url, item.jumpType)"
          class="menu_item"
          @mouseover="showItem(item, index)"
        >
          {{ item.name }}
          <i v-show="item.children" class="el-icon-arrow-down"></i>
        </div>
        <transition name="el-zoom-in-top">
          <!-- v-show="showmenu && item.children && zoomIndex == index" -->
          <div class="transition-wrapper" v-show="showmenu && item.children && zoomIndex == index">
            <div class="transition-seat"></div>
            <div class="transition-box" :style="{ width: changeWidth(item.name) }">
              <p
                @click="changePath(index, list.url, list.jumpType)"
                v-for="(list, index1) in item.children"
                :key="index1"
              >
                {{ list.name }}
              </p>
            </div>
          </div>
        </transition>
        <div class="item-underLine" :style="{ bottom: `${underlineBottom}px` }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { oldMallBaseUrl } from '@/modules/projectA/api/urlConfig';
export default {
  props: {
    underlineBottom: {
      type: Number,
      default: 0,
    },
    headerMenuList: {
      type: Array,
      default: () => [],
    },
    zoneMenu: {
      type: String,
      default: '',
    },
  },
  inject: {
    activeIndexObj: {
      from: 'activeIndexObj',
      default: () => ({
        activeIndex: -10,
      }),
    },
  },
  data() {
    return {
      // activeIndex:1,
      showmenu: false,
      // menuList:headerMenuList,
    };
  },
  methods: {
    // ...mapMutations(['SEARCH_WORD']),
    async changePath(index, url, jumpType) {
      this.activeIndex = index + 1;
      if (index == 0) {
        // this.SEARCH_WORD('');
      }
      if (url !== '/') {
        // if(url == `${oldMallBaseUrl}/ecmall/payAccount/toPayAccount.do`){
        //   let res = await this.$request.queryIsAdmin()
        //   if(!res.data) {
        //     this.$message.warning('易支付只有管理员才能使用，请联系该企业管理员！');
        //     return;
        //   }
        // }
        window.open(url, jumpType);
      }
    },
    showItem(item, index) {
      this.zoomIndex = index;
      if (item.children) {
        this.showmenu = true;
      }
    },
    leave() {
      this.showmenu = false;
    },
    changeWidth(name) {
      let width = 'auto';
      switch (name) {
        case '综合服务':
          width = '162px';
          break;
        // case "工业品展": width = '160px'
        //   break;
        case '特色专区':
          width = '234px';

          break;
        default:
          width = 'auto';
      }
      return width;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.header_menu {
  width: 100%;
  background: rgba(255, 255, 255, 0.4);
  color: #333;
  // margin-left:20px;
  .menu_box {
    //  width:1200px;
    margin: 0 auto;
  }
  .menu_content {
    position: relative;
  }
  .menuActive {
    position: relative;
    .menu_item {
      color: $main-col;
    }
    .item-underLine {
      transform: scaleX(1);
    }
  }
  .item-underLine {
    transform: scaleX(0);
    transform-origin: 50% 50%;
    transition: transform 0.3s ease;
    margin: 0 15px;
    border-bottom: 2px solid $main-col;
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
  }
  .menu_item {
    margin: 0 6px;
    cursor: pointer;
    line-height: 40px;
    height: 40px;
    align-items: center;
    font-size: 16px;
    i {
      font-weight: bold;
      margin-left: 0px;
    }
  }
  .menu_item:hover {
    font-weight: bold;
    color: $main-col;
  }
  .transition-wrapper {
    z-index: 1000;
    position: absolute;
    // top: 58px;
    top: 38px;
    left: 0;
    right: 0;
  }
  .transition-seat {
    width: 100%;
    height: 12px;
  }

  .transition-box {
    display: flex;
    background: #fff;
    padding: 0 0 0 10px;
    // padding: 10px 0 10px 10px;

    flex-wrap: wrap;
    width: 162px;
    box-shadow: 0px 3px 4px rgba(163, 163, 163, 0.25);
    p {
      line-height: 36px;
      cursor: pointer;
      min-width: 84px;
      margin-right: 20px;
    }
    p:hover {
      color: $main-col;
    }
  }
}
</style>
